const $ = require('jquery');
const thdCustomer = require('@thd-olt-global/thd-customer');

const config = {
  perksLink: '#myaccount-perks-page',
};

const enrolledInPerksProgram = 'isEnrolledInPerksProgram';
class HeaderPerks {
  constructor() {}

  triggerPerks() {
    const role = thdCustomer.default.role;
    if (
      sessionStorage &&
      !sessionStorage.getItem(enrolledInPerksProgram) &&
      role &&
      role.toLowerCase() === 'admin'
    ) {
      thdCustomer.default.getLoyaltyPerks('').then((result) => {
        var res = JSON.parse(result);
        if (res.enrolledInPerksProgram) {
          $(config.perksLink).removeClass('u--hide');
        }
      });
    } else if (sessionStorage.getItem(enrolledInPerksProgram) === 'true') {
      $(config.perksLink).removeClass('u--hide');
    }
  }
  init() {
    this.triggerPerks();
  }
}

module.exports = new HeaderPerks();
